import React, { useState, useEffect } from "react";
import { BgLoader, TableZero, PageError } from "../../ui";
import { useOutletContext, Link } from "react-router-dom";
import { instance } from "../../axios";
import { Helmet } from "react-helmet";
import { Tree, ConfigProvider } from 'antd';
import { toast } from "react-toastify";
const { DirectoryTree } = Tree;


export default function QuickDocs() {
  const [state, setState] = useState({});
  const [pstate, setTitle] = useOutletContext(); // <-- access context value
  const [docloaded, isDocLoaded] = useState(false);
  const [state1, setState1] = useState({});
  const [filelist, setFiles] = useState([]);
  const [dloader, showDLoader] = useState(false);

  const fetchData1 = () => {
    isDocLoaded(false)
    instance
      .get("/quick_docs")
      .then(function (response) {
        isDocLoaded(true)
        setState1({ ...state1, ...response.data });
        setFiles(response.data.dir);
      })
      .catch(function (error) { })
      .then(function () { });

  }


  const updateTreeData = (list, key, children) =>
    list.map((node) => {
      if (node.key === key) {
        return {
          ...node,
          children,
        };
      }
      if (node.children) {
        return {
          ...node,
          children: updateTreeData(node.children, key, children),
        };
      }
      return node;
    });




  const onLoadData = ({ key, children, type }) =>

    new Promise((resolve) => {
      if (children) {
        resolve();
        return;
      }

      instance
        .get("/quick_docs?type=" + type + "&key=" + key)
        .then(function (response) {

          setFiles((origin) => updateTreeData(origin, key, response.data.dir));
          resolve();
        })



    });


  const downloadFile = (e) => {

    if (e.isLeaf == true) {
      showDLoader(true)
      instance
        .get("/cust_file_download?doc=" + encodeURIComponent(e.title) + "&id=" + e.id)
        .then(function (response) {
          showDLoader(false)
          if (response.data.status == 'success') {

            const link = document.createElement('a');
            link.href = response.data.url;
            link.download = e.title;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            toast(response.data.msg, { type: "error" });
          }
        })
    }
  }


  useEffect(() => {
    setTitle("Quick Docs.")
    fetchData1()

  }, []);


  if (state1.status == 'error') {
    return (
      <PageError msg={state1.msg} />
    )
  }

  if (pstate.company.doc_directory == 0) {
    return (
      <PageError msg='Access denied!' />
    )
  }

  return (
    <div>
      <Helmet>
        <title>Quick Documents</title>
        {pstate.company && pstate.company.logo && <link rel="icon" type="image/x-icon" href={pstate.company.logo}></link>}
      </Helmet>
      {dloader && (
        <div className="overlay">
          <div className="overlay__inner">
            <div className="overlay__content"><span className="spinner"></span></div>
          </div>
        </div>
      )}
      {docloaded == true ?
        <>
          {filelist.length > 0 ?
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: '#6c757d',

                }
              }}

            >
              <DirectoryTree
                className="bg-transparent"
                loadData={onLoadData}
                showIcon
                onSelect={(e, c) => downloadFile(c.node)}
                treeData={filelist}

              />
            </ConfigProvider>
            : <TableZero title="Documents" />
          }
        </>

        : <BgLoader />}
    </div>
  );
}
